if (!customElements.get("m-size-chart-modal")) {
  customElements.define(
    "m-size-chart-modal",
    class MSizeChartModal extends HTMLElement {
      constructor() {
        super();
        this.selectors = {
          openButton: "[data-open-size-chart]",
          content: ".m-size-chart-modal__template",
        };
      }

      connectedCallback() {
        this.domNodes = queryDomNodes ? queryDomNodes(this.selectors, this) : {
          openButton: this.querySelector(this.selectors.openButton),
          content: this.querySelector(this.selectors.content),
        };
        this.colorScheme = this.dataset.colorScheme || "m-color-default";
        this.init();
      }

      init() {
        if (typeof MinimogTheme !== "undefined" && MinimogTheme.Modal) {
          this.modal = new MinimogTheme.Modal();
        }

        const openButtons = document.querySelectorAll(this.selectors.openButton);
        openButtons.forEach((btn) => {
          btn.addEventListener("click", (e) => {
            e.preventDefault();
            this.openModal();
          });
        });

        // Delegate unit switch tabs
        document.addEventListener("click", (e) => {
          const tab = e.target.closest(".m-size-chart-tab");
          if (!tab) return;
          const container = tab.closest(".m-size-chart-modal__wrapper");
          if (!container) return;

          const unit = tab.dataset.unit;
          container.querySelectorAll(".m-size-chart-tab").forEach((t) => t.classList.remove("is-active"));
          tab.classList.add("is-active");

          container.querySelectorAll(".m-size-chart-unit-content").forEach((el) => {
            if (el.dataset.unit === unit) {
              el.classList.remove("m:hidden");
            } else {
              el.classList.add("m:hidden");
            }
          });
        });
      }

      openModal() {
        const contentEl = this.querySelector(this.selectors.content);
        if (!contentEl) return;

        if (this.modal) {
          const html = document.createElement("DIV");
          html.className = "m-size-chart-modal__wrapper";
          html.innerHTML = contentEl.innerHTML;
          this.modal.appendChild(html);
          this.modal.setWidth("720px");
          this.modal.setSizes(`m-size-chart-modal-dialog m-gradient ${this.colorScheme}`);
          this.modal.open();
        } else {
          // Fallback standalone modal
          let fallback = document.getElementById("m-size-chart-fallback-modal");
          if (!fallback) {
            fallback = document.createElement("dialog");
            fallback.id = "m-size-chart-fallback-modal";
            fallback.style.cssText = "border:none;border-radius:8px;padding:0;max-width:720px;width:90vw;box-shadow:0 10px 40px rgba(0,0,0,0.2);";
            document.body.appendChild(fallback);
          }
          fallback.innerHTML = `
            <div style="position:relative;padding:24px;">
              <button type="button" style="position:absolute;top:12px;right:12px;background:none;border:none;font-size:20px;cursor:pointer;" onclick="this.closest('dialog').close()">&times;</button>
              ${contentEl.innerHTML}
            </div>
          `;
          fallback.showModal();
        }
      }
    }
  );
}
